<template>
  <div>
    <div class="home-all">
      <div class="home-contain">
        <Header></Header>
        <!-- <ul class="text-top">
          <li>职业教育</li>
          <li>前途广阔</li>
          <li>大有可为</li>
        </ul>-->
        <img src="/image/headText.png" class="headText" alt />
        <typeNav></typeNav>
        <div class="bigBox1">
          <div class="swiper-box">
            <!--banner轮播-->
            <div class="swiper-container" ref="mySwiper">
              <!-- swiper-wrapper里面每一个slider即为一张图片 -->
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                  <img :src="`${baseUrl}${item.imgUrl}`" class="swiper-img" v-if="!item.forwardUrl" />
                  <a
                    :href="item.forwardUrl"
                    target="_blank"
                    rel="noopenner noreferrer"
                    class="footer-nav-item"
                    v-else
                  >
                    <img :src="`${baseUrl}${item.imgUrl}`" class="swiper-img" />
                  </a>
                </div>
              </div>

              <!-- 如果需要分页器 -->
              <div class="swiper-pagination"></div>

              <!-- 如果需要导航按钮 -->
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
          <div class="bigBox1-right">
            <div class="box1">
              <em class="box1-left">通知公告</em>
              <!-- <router-link
                :to="`/notice/${typeNavList[1].primaryColName}?id=${typeNavList[1].id}`"
                class="box1-right"
              >更多 >></router-link>-->
              <span class="box1-right" @click="gotoNotice()">更多 >></span>
            </div>
            <ul
              v-for="(item,index) in homeNoticeList"
              :key="index"
              @mouseenter="enterNotice(index)"
            >
              <li
                class="box2"
                :class="{ active:noticeIndex == index }"
                @click="item.articleLink?openInNewTab(item.articleLink):chooseNotice(item)"
                @mouseleave="leaveNotice"
              >
                <div class="box2-item">
                  <img src="/image/icon1.png" alt />
                  <div class="text-box">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2">{{item.title}}</p>
                  </div>
                  <span
                    class="data-box"
                  >{{item.effectStartTime!=null?item.effectStartTime.split(" ")[0]:''}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <p class="bigBox2">最新发布</p>
        <div class="bigBox3">
          <div v-for="(item,index) in homeNewsList" :key="index">
            <div
              class="bigBox3-item"
              @click="item.articleLink?openInNewTab(item.articleLink):chooseNotice(item)"
            >
              <img :src="`${baseUrl}${item.coverUrl}`" alt class="bigBox3-item-img" />
              <p class="bigBox3-item-p1">{{item.title}}</p>
              <p class="bigBox3-item-p2">
                {{item.summary
                }}
              </p>
              <div class="bigBox3-item-bottom">
                <span
                  class="span1"
                >{{item.effectStartTime!=null?item.effectStartTime.split("-")[2].split(" ")[0]:''}}/{{item.effectStartTime!=null?item.effectStartTime.split("-")[1]:''}}</span>
                <span
                  class="span2"
                >{{item.effectStartTime!=null?item.effectStartTime.split("-")[0]:''}}</span>
                <span class="span3">查看 ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  watch: {
    bannerList: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          //初始化Swiper类的实例
          var mySwiper = new Swiper(this.$refs.mySwiper, {
            //设置轮播图防线
            direction: "horizontal",
            //开启循环模式
            loop: true,
            // 如果需要分页器
            pagination: {
              el: ".swiper-pagination",
              //分页器类型
              type: "bullets",
              //点击分页器，切换轮播
              clickable: true
            },
            //自动轮播
            autoplay: {
              delay: 3000,
              //新版本的写法：目前是5版本
              // pauseOnMouseEnter: true,
              //如果设置为true，当切换到最后一个slide时停止自动切换
              stopOnLastSlide: true,
              //用户操作swiper之后，是否禁止autoplay
              disableOnInteraction: false
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            }
            //切换效果
            // effect: "cube",
          });

          //1:swiper插件,对外暴露一个Swiper构造函数
          //2:Swiper构造函数需要传递参数 1、结构总根节点CSS选择器|根节点真实DOM节点  2、轮播图配置项
          //鼠标进入停止轮播
          mySwiper.el.onmouseover = function() {
            mySwiper.autoplay.stop();
          };
          //鼠标离开开始轮播
          mySwiper.el.onmouseout = function() {
            mySwiper.autoplay.start();
          };
        });
      }
    }
  },
  computed: {
    ...mapState({
      bannerList: state => state.home.bannerList,
      typeNavList: state => state.home.typeNavList,
      homeNoticeList: state => state.home.homeNoticeList,
      homeNewsList: state => state.home.homeNewsList
    }),
    // fullImageUrl() {
    // console.log(imgUrl)
    // console.log(`${process.env.VUE_APP_BASE_API}${this.imageUrl}`);
    // return window.location.origin + "/edu-api/" + this.imageUrl;
    //   return `${process.env.VUE_APP_BASE_API}${this.imgUrl}`;
    // },
    baseUrl() {
      return window.location.origin + "/edu-api";
    }
  },
  data() {
    return {
      noticeIndex: -1,
      //收集用户输入的关键字
      keyword: ""
    };
  },
  mounted() {
    this.$store.dispatch("getBannerList");
    this.$store.dispatch("getHomeNoticeList");
    this.$store.dispatch("getHomeNewsList");
  },
  methods: {
    gotoNotice() {
      this.$router.push({
        name: "通知公告",
        params: { primaryColName: this.typeNavList[1].primaryColName },
        query: { id: this.typeNavList[1].id }
      });
    },
    enterNotice(index) {
      this.noticeIndex = index;
    },
    leaveNotice() {
      this.noticeIndex = -1;
    },
    chooseNotice(item) {
      // console.log(item);
      this.$router.push({
        name: "detail",
        query: { id: item.id }
      });
    },
    openInNewTab(link) {
      window.open(link, "_blank");
    }
  }
};
</script>

<style scoped lang="less">
.home-all {
  background-image: url(~@/assets/bg1.png),
    linear-gradient(181deg, #3a9fea 0%, #95cbf4 50%, #dcf0ff 100%);
  background-size: cover, cover; /* 确保云图和渐变背景都覆盖整个页面 */
  background-repeat: no-repeat, no-repeat; /* 防止背景重复 */
  margin: 0 auto;
  width: 100%;
}
.home-contain {
  width: 1200px;
  margin: 0 auto;
  .headText {
    margin: 11px 75px 26px 75px;
    width: 1050px;
    height: 54px;
  }
  // .text-top {
  //   padding: 0 60px;
  //   padding-bottom: 24px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  // li {
  //   font-size: 56px;
  //   font-family: MyFont;
  //   font-weight: 400;
  //   color: #ff0000;
  //   letter-spacing: 8px;
  // }
  // }
  .bigBox1 {
    width: 1200px;
    display: flex;
    .swiper-box {
      box-sizing: border-box;
      width: 650px;
      height: 390px;
      .swiper-container {
        --swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
        --swiper-navigation-size: 30px; /* 设置按钮大小 */
        --swiper-pagination-color: #fff; /* 两种都可以 */
      }
      .swiper-img {
        width: 650px;
        height: 390px;
        border-radius: 0px 0px 0px 8px;
      }
    }
    .bigBox1-right {
      // height: 365px;
      flex: 1;
      padding: 18px 30px;
      background: #fff;
      // overflow: hidden;
      border-radius: 0px 0px 8px 0px;
      .box1 {
        padding-bottom: 8px;
        border-bottom: 2px solid rgba(18, 68, 155, 0.2);
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .box1-left {
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #002075;
        }
        .box1-right {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 0.5);
          cursor: pointer;
          &:hover {
            color: #3a9fea;
            text-decoration: underline;
          }
        }
      }
      .box2 {
        padding: 16px 0;
        border-bottom: 2px solid rgba(18, 68, 155, 0.2);
        cursor: pointer;
        .box2-item {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
          .text-box {
            margin-left: 11px;
            width: 330px;
            .p1 {
              width: 300px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #0052D9;
              display: -webkit-box;
              overflow: hidden; /*超出隐藏*/
              text-overflow: ellipsis; /*隐藏后添加省略号*/
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1; /*想显示多少行*/
            }
            .p2 {
              margin-top: 6px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #99A2C6;
              display: -webkit-box;
              overflow: hidden; /*超出隐藏*/
              text-overflow: ellipsis; /*隐藏后添加省略号*/
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1; /*想显示多少行*/
            }
          }
          .data-box {
            margin-left: 42px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #99A2C6;
          }
        }
      }
      .active {
        box-shadow: 0px 2px 4px 0px rgba(98, 115, 197, 0.3);
      }
    }
  }
  .bigBox2 {
    padding: 36px 0 16px 0;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #002075;
  }
  .bigBox3 {
    width: 1200px;
    padding-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .bigBox3-item {
      border-radius: 8px;
      padding: 12px 16px;
      width: 338px;
      height: 400px;
      background: #ffffff;
      box-shadow: 0px 2px 22px -14px rgba(42, 61, 121, 0.5);
      display: flex;
      flex-direction: column;
      cursor: pointer;
      img {
        width: 338px;
        height: 200px;
      }
      .bigBox3-item-p1 {
        margin: 12px 0;
        padding-top: 16px;
        border-top: 2px solid #f2f2f2;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #002075;
        line-height: 28px;
        display: -webkit-box;
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*隐藏后添加省略号*/
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /*想显示多少行*/
      }
      .bigBox3-item-p2 {
        margin-bottom: auto;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        display: -webkit-box;
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*隐藏后添加省略号*/
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /*想显示多少行*/
      }
      .bigBox3-item-bottom {
        display: flex;
        align-items: flex-end;
        .span1 {
          font-size: 24px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #134cb1;
          line-height: 24px;
        }
        .span2 {
          margin-left: 12px;
          margin-right: auto;
          font-size: 16px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #333333;
        }
        .span3 {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
        }
      }
    }
  }
}

@media only screen and (min-width: 993px) {
  .home-all {
    background-image: url(~@/assets/bg1.png),
      linear-gradient(181deg, #3a9fea 0%, #95cbf4 50%, #dcf0ff 100%);
    background-size: cover, cover; /* 确保云图和渐变背景都覆盖整个页面 */
    background-repeat: no-repeat, no-repeat; /* 防止背景重复 */
    margin: 0 auto;
    width: 100%;
  }

  .home-contain {
    width: 1200px;
    margin: 0 auto;
    .headText {
      margin: 11px 75px 26px 75px;
      width: 1050px;
      height: 54px;
    }
    // .text-top {
    //   padding: 0 60px;
    //   padding-bottom: 24px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    // li {
    //   font-size: 56px;
    //   font-family: MyFont;
    //   font-weight: 400;
    //   color: #ff0000;
    //   letter-spacing: 8px;
    // }
    // }
    .bigBox1 {
      width: 1200px;
      display: flex;
      .swiper-box {
        box-sizing: border-box;
        width: 650px;
        height: 390px;
        .swiper-container {
          --swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
          --swiper-navigation-size: 30px; /* 设置按钮大小 */
          --swiper-pagination-color: #fff; /* 两种都可以 */
        }
        .swiper-img {
          border-radius: 0px 0px 0px 8px;
          width: 650px;
          height: 390px;
        }
      }
      .bigBox1-right {
        // height: 365px;
        flex: 1;
        padding: 18px 30px;
        background: #fff;
        // overflow: hidden;
        .box1 {
          padding-bottom: 8px;
          border-bottom: 2px solid rgba(18, 68, 155, 0.2);
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          .box1-left {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #002075;
          }
          .box1-right {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 0.5);
            cursor: pointer;
            &:hover {
              color: #3a9fea;
              text-decoration: underline;
            }
          }
        }
        .box2 {
          padding: 16px 0;
          border-bottom: 2px solid rgba(18, 68, 155, 0.2);
          cursor: pointer;
          .box2-item {
            display: flex;
            align-items: center;
            img {
              width: 24px;
              height: 24px;
            }
            .text-box {
              margin-left: 11px;
              width: 330px;
              .p1 {
                width: 300px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #0052D9;
                display: -webkit-box;
                overflow: hidden; /*超出隐藏*/
                text-overflow: ellipsis; /*隐藏后添加省略号*/
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1; /*想显示多少行*/
              }
              .p2 {
                margin-top: 6px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #99A2C6;
                display: -webkit-box;
                overflow: hidden; /*超出隐藏*/
                text-overflow: ellipsis; /*隐藏后添加省略号*/
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1; /*想显示多少行*/
              }
            }
            .data-box {
              margin-left: 42px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #99A2C6;
            }
          }
        }
        .active {
          box-shadow: 0px 2px 4px 0px rgba(98, 115, 197, 0.3);
        }
      }
    }
    .bigBox2 {
      padding: 36px 0 16px 0;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #002075;
    }
    .bigBox3 {
      width: 1200px;
      padding-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .bigBox3-item {
        border-radius: 8px;
        padding: 12px 16px;
        width: 338px;
        height: 400px;
        background: #ffffff;
        box-shadow: 0px 2px 22px -14px rgba(42, 61, 121, 0.5);
        display: flex;
        flex-direction: column;
        cursor: pointer;
        img {
          width: 338px;
          height: 200px;
        }
        .bigBox3-item-p1 {
          margin: 12px 0;
          padding-top: 16px;
          border-top: 2px solid #f2f2f2;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #002075;
          line-height: 28px;
          display: -webkit-box;
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis; /*隐藏后添加省略号*/
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /*想显示多少行*/
        }
        .bigBox3-item-p2 {
          margin-bottom: auto;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          display: -webkit-box;
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis; /*隐藏后添加省略号*/
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /*想显示多少行*/
        }
        .bigBox3-item-bottom {
          display: flex;
          align-items: flex-end;
          .span1 {
            font-size: 24px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #134cb1;
            line-height: 24px;
          }
          .span2 {
            margin-left: 12px;
            margin-right: auto;
            font-size: 16px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #333333;
          }
          .span3 {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>